import { render } from "./TicketsRisposti.vue?vue&type=template&id=51ffedf0&scoped=true"
import script from "./TicketsRisposti.vue?vue&type=script&lang=js"
export * from "./TicketsRisposti.vue?vue&type=script&lang=js"

import "./TicketsRisposti.vue?vue&type=style&index=0&id=51ffedf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ffedf0"]])

export default __exports__